import { EThemes } from 'types/commonEnums';
import { EAccountStatuses } from 'types/userTypes';
import { ICleanStoreAction } from 'store/reducers/types';

export interface IUserData {
  createdDate: string,
  email: string,
  fromChannel: null | number,
  id: number,
  language: number,
  name: string,
  nextSubscriptionPayment: number,
  onboardingStatus: null | any,
  onboradingFinished: boolean,
  privileges: null | any,
  source: number,
  status: number,
  ticketsUrl: string,
  permissions: string,
  isEmailVerified: boolean,
  phoneNumber: string,
  cognitoUsername: string,
}

export interface IUserSettings {
  theme: EThemes,
  isCollapsedLeftPanel: boolean,
  id: number,
  currency: string,
  region: string,
  language: number,
  denialCause: null | string,
  isUpdated: boolean,
  approvalStatus: EAccountStatuses,
  cognitoUsername: string,
  isOnboardingFinished: boolean,
  onBoardingSteps: boolean[];
}

export interface IUser {
  isLoading: boolean,
  isAuthenticated: boolean,
  data: IUserData,
  settings: IUserSettings,
}

export enum UserActionsEnum {
  SET_LEFT_PANEL = 'SET_LEFT_PANEL',
  SET_THEME = 'SET_THEME',
  SET_CURRENT_USER = 'SET_CURRENT_USER',
  UPDATE_USER = 'UPDATE_USER',
  GET_USER_SETTINGS = 'GET_USER_SETTINGS',
}

export interface ISetLeftPanelAction {
  type: UserActionsEnum.SET_LEFT_PANEL,
  payload: { isCollapsedLeftPanel: boolean; },
}

export interface ISetThemeAction {
  type: UserActionsEnum.SET_THEME,
  payload: { theme: EThemes },
}

export interface ISetUserDataActionPayload {
  data?: IUserData;
  isLoading?: boolean;
}

export interface ISetCurrentUserAction {
  type: UserActionsEnum.SET_CURRENT_USER,
  payload: ISetUserDataActionPayload,
}

export interface IUpdateUserAction {
  type: UserActionsEnum.UPDATE_USER,
  payload: any,
}

export interface IGetUserSettingsAction {
  type: UserActionsEnum.GET_USER_SETTINGS,
  payload: Omit<IUserSettings, 'theme' | 'isCollapsedLeftPanel'>
}

export type UserActions =
  ISetLeftPanelAction
  | ISetThemeAction
  | ISetCurrentUserAction
  | IUpdateUserAction
  | IGetUserSettingsAction
  | ICleanStoreAction

